<template>
 <div class="cmp-catalog-statement-statement_list dt-page">
   <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button" style="margin-right: -20px">
        <div class="dt-icon-container">
          <img
           
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
            @click="onAddTaskClicked"
          />
        </div>
       
      </div>
      <div class="search">
        <Dropdown
          :options="chapterTV"
          style="margin-top:-1px;margin-left:20px;min-width:120px;;margin-right:20px;"
          :placeholder="$t('chapter_string')"
          deselect
          borderbottom
          :selected="chapterTV.find(x=>x.value == basicFilter['chapter'])"
          @selectedChange="e => onDropdownChange('chapter', e)"
        /> 
        <InputField
          :value="basicFilter.searchString"
          :placeholder="'Search'"
          :config="{
            borderStyle: 'bottom',
            maxWidth:'250px',
            minWidth:'250px',
            width:'250px',
          }"
           @keyup="onSearchInputKeyup"
        />

        <Dropdown
          :options="statusTV"
          style="margin-top:-1px;margin-left:20px;min-width:110px"
          :placeholder="$t('status')"
          deselect
          borderbottom
          multiple
          :selected="selectedDict['status']"
          @selectedChange="e => onDropdownChange('status', e)"
        /> 

        <DatePicker2
          class="shrink-margin"
          id="start"
          :showLabel="false"
          :value="basicFilter.start"
          @input="onDateChange"
          lw="70px"
          cw="110px"
          :hoverStyle="1"
          :placeholder="$dft.capHead($t('start'))"
          style="margin-top:-1px; margin-left: 8px !important;width: 100px"
        />

        <DatePicker2
          class="shrink-margin"
          id="end"
          style="margin-top:-1px; margin-left: 8px !important; width: 100px"
          :showLabel="false"
          :value="basicFilter.end"
          @input="onDateChange"
          lw="70px"
          cw="110px"
          :hoverStyle="1"
          :placeholder="$dft.capHead($t('end'))"
        />

        <Dropdown
          :options="usersTV"
          style="margin-top:-1px;margin-left:20px;min-width:140px"
          :placeholder="$t('sent_user')"
          deselect
          borderbottom
          multiple
          :selected="selectedDict['sent_user']"
          @selectedChange="e => onDropdownChange('sent_user', e)"
        /> 

        <Dropdown
          :options="usersTV"
          style="margin-top:-1px;margin-left:20px;min-width:140px"
          :placeholder="$t('assigned_user')"
          deselect
          borderbottom
          multiple
          :selected="selectedDict['assigned_users']"
          @selectedChange="e => onDropdownChange('assigned_users', e)"
        /> 
       
        <!-- {{ basicFilter['assigned_users'] }} -->
        
      </div>

    </div> 
    <!-- @scrollnext="onAccountsNext" -->
    <!-- :loadingFlag="loadingFlag" -->

     <div class="dt-page--body"> 
      <NTable
        id="catalog-statement-statement_list"
        class="h1"
        :config="tableConfig"
        :headers="tableHeaders"
        :items="list"
         
       
      >  

      <!-- :class="{
              selected: selectedRow(item)
                          @click="onRowClicked(item)"
            }" -->
         <template v-slot:item="{ item, tdcon }"> 
           <tr :title="item['tooltip_task']">
            <td v-bind="tdcon('chapter_string')">
              <span>{{ item["chapter"] }}</span>
            </td>
            <td v-bind="tdcon('source_account')" >
              <span @click="onSourceClick(item)" class="ut-link ut-text-accent5">{{ item["source"] }}</span>
            </td> 


            
            
            <td v-bind="tdcon('task')">
              <span class="ut-link ut-text-accent5" @click="onTaskClick(item)" >{{ item["task"] }}</span>
            </td> 
             <td v-bind="tdcon('status')">
              <!-- <span>{{ item["status"] }}</span> -->
              <Dropdown
                :options="statusTV"
                :selected="
                  statusTV.find(
                    (e) => e.value == item['status']
                  )
                "
                :style="{
                  'min-height': '28px',
                  'min-width':'85px'
                }"
                :placeholder="$t('status')"
                deselect
                box
                :showExpandedLabel="false"
                v-on:selectedChange="(e) => onStatusSelect(item, e)"
              />

            </td>

            <td v-bind="tdcon('due_date')" >

              <span>{{ item["due_date"] }}</span>
            </td>

            <td v-bind="tdcon('users')">
              <span>{{ item["users"] }}</span>
            </td>
            <td v-bind="tdcon('notes')">
              <span>{{ item["notes"] }}</span>
            </td>

            <!-- <td v-bind="tdcon('options')">
              <img
                @click.stop="e => deleteAccount(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s2 ut-center"
              />
            </td> -->
          </tr>
        </template> 
       </NTable>

    
   </div>
    <!-- <DtPageStatusFloat :statusTV="statusTV" />
    <Sidewindow
      :value="licenceAccountsDetailsFlag"
      @closed="onCloseLicenceAccountsDetails"
    > 
       <AccountSidewindow :licenceAccountsDetails="licenceAccountsDetails" /> 
     </Sidewindow>  -->

     <!-- <ModalContainer :modalKey="'advanceSearch'" width="small">
      <AdvancedSearch
        :advancedSearchData="advancedSearchData"
        :initSearchFilter="searchFilter"
        @search="onAdvancedSearch"
        @cancelled="onCancel"
      />
    </ModalContainer> -->


    <ModalContainer :modalKey="'addTaskModal'" width="small">
      <AddTaskModal
        @cancelled="onCancel"
        @insert="onTaskAdd"
        @update="onUpdateTask"
        :existingTask="taskToLoad"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'editTaskModal'" width="small">
      <EditTaskModal
         @cancelled="onCancel"
        @onSubmit="onEditTask"
      />
    </ModalContainer>


  </div>
</template>

<script>
 import Modal from '../../../../dt-plugins/modal/modal';
import { TaskStoreNamespace as storeNS } from "../../store";
 import * as ActionTypes from "../../store/types";
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";

import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";
import { createNTableConfig } from "../../../../plugins/datatable";

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";
import AddTaskModal from "../task/add-task-modal.vue";

import { createModalMixin,closeModalRoute,openModalRoute2 } from "../../../../dt-plugins/modal/modal.mixin";


import { mapGetterObject, mapActionObject } from "../../../../store/global";

import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import { tasksActions } from '../../store/task/actions';
import { tasksGetters } from '../../store/task/getters';
import { productsListLDTRoutes, releasesListLDTRoutes } from '../../../catalog/router/routes';
import { licencesListLDTRoutes } from '../../../licensing/router/routes';
import { royaltyContractsListLDTRoutes } from '../../../royalty/router/routes';

import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import { taskListAdvancedSearchConfig } from './advanced-search.vue';
import { format } from "date-fns";

import EditTaskModal from "@dtplugins/dt-task/dt-task-load-single-modal.vue";

import AdvancedSearch from './advanced-search.vue';
import { taskService } from "../../services/tasks.service";
// import DtPageStatusFloat from "@dtplugins/dtpage-status/dtpage-status-float";
// const LDTConfig = {
//   entityName: "licence_account",
//   ldtRoutes: licenceAccountsListLDTRoutes,
//   detailsSelectableFunction: getlicenceAccountsDetailsSelectable,
//   primaryKey: "licence_account_id",
//   storeNs: storeNS,
//   SELECT_ACTION: ActionTypes.LicenceAccountsDetails.FETCH.SINGLE,
//   SELECT_AUTO_ACTION: ActionTypes.LicenceAccountsDetails.FETCH.SINGLE
// };

export default {
  components: {
    NTable,
    
    InputField,
    DTIconButton,
    ModalContainer,
    EditTaskModal,
    AddTaskModal,
    AdvancedSearch,

  },
  mounted: function() {
  
  },
  data: function() {
    return {
      taskToLoad:{},
      selectedDict:{
        status:[     {text:'open',value:'open'},
          {text:'pending',value:'pending'},
          {text:'question',value:'question'},  ],
        sent_user:[],
        assigned_users:[],
        chapter:[]
      },
   
      
      // selectedClickedLicenceAccount: null,
      // msg:'',
      // modal2Data:{},

      // //defaultConfig: defaultConfig,
      // searchType: "none" // release__standard_search, release__weekly_search, release__monthly_search
    };
  },
  mixins: [
    // createLDTHost(LDTConfig),

    createFetchListMixin(ActionTypes.TasksList.FETCH.ALL, 100, {
      advancedSearchable: false,
      searchable: true,
      scrollable: true,
    }),
    createModalMixin("addTaskModal"),
    createModalMixin("editTaskModal"),
    // createAdvancedSearchHost( taskListAdvancedSearchConfig ),
    // createModalMixin("advanceSearch"),

    // createAdvancedSearchHost(releaseListAdvancedSearchConfig, {
    //   onBeforeAdvancedSearchFetch:
    //     "onBeforeAdvancedSearchFetch",
    // }),
  ],
  watch: {
    $route: {
      immediate: true,
      handler: function(to, from) {}
    },
    usersTV: function (newVal, oldVal) {
      if(newVal && this.selectedDict['assigned_users'].length<1){
        //const usersTV = (this.tasksList?.users || []).map(r => ({text: r.user_name, value: r.user_id}));
        const currentUserId =  this.$store?.getters?.account?.user?.user_id||''
        console.log("PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP",newVal.find(x=>x.value==currentUserId))

        this.selectedDict['assigned_users'] = [{...newVal.find(x=>x.value==currentUserId)}]
      }

    }
  },
  computed: {
    ...mapGetterObject(storeNS, tasksGetters),
    filter: function() {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter
      };
    },
    selectedAssignedUser:function(){
      
      return this.selectedDict['assigned_users']
    },



    chapterTV:function(){
      const tv = (this.tasksList?.chapters || []).map(r => ({text: this.$t(r.external_table), value: r.external_table}));
     

      return tv;
    },
    usersTV:function(){
      
      const usersTV = (this.tasksList?.users || []).map(r => ({text: r.user_name, value: r.user_id}));

      return usersTV;
    },
    statusTV: function() {
      return [
          {text:'open',value:'open'},
          {text:'pending',value:'pending'},
          {text:'question',value:'question'},
          {text:'done',value:'done'},
          {text:'rejected',value:'rejected'},
        ]
    },

    tableConfig: function() {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40
      });
    },
    list: function() {
      console.log(this.tasksList,"::::::::")
      return this.tasksList?.tasks || [];
    },

    tableHeaders: function() {
      return [
        createTableHeader("chapter_string", {  }),
        createTableHeader("source_account", { }),
        createTableHeader("task", {}),
        createTableHeader("status", {}),
        
        createTableHeader("due_date", {}),
        createTableHeader("users", {}),
        
        createTableHeader("notes", {}),
      ];
    },

    
  },
  methods: {
    ...mapActionObject(storeNS, tasksActions),

    defaultBasicFilter() {
      //<-- Needed for BasicSearch. Provide the basic Filter Object. Supports String/Boolean/Number
      return {
        searchString: undefined,
        status: 'open,pending,question',
        sent_user:undefined,
        start: undefined,
        end:format(new Date(new Date().setDate(new Date().getDate() + 30)), "YYYY-MM-DD"),
        assigned_users:this.$store?.getters?.account?.user?.user_id,
        chapter:undefined
      };
    },
    onAddTaskClicked: function() {
      openModalRoute2(this,'addTaskModal',{mode:'add'});
    },

    onUpdateTask:function(payload){
      console.log("PAYLOAD",payload)
      this[ActionTypes.TasksList.UPDATE.SINGLE]({
        ...payload
      });
    },

    onStatusSelect: function (item, value) {
      this[ActionTypes.TasksList.UPDATE.SINGLE]({
        name: "status",
        item: item,
        value: value.value,
      });
    },

    onSourceClick:function(item){
      const ldtRoutesDict = [
        { key:'release_id',chapter:'Release',ldtRoute:releasesListLDTRoutes},
        { key:'product_id',chapter:'Product',ldtRoute:productsListLDTRoutes},
        {key:'licence_id', chapter:'Licence',ldtRoute:licencesListLDTRoutes},
        { key:'contract_id',chapter:'Contract' , ldtRoute:royaltyContractsListLDTRoutes }
      ]

      const LdtRoute  = ldtRoutesDict.find(x=>x.chapter==item.chapter).ldtRoute;
      const p_Key  = ldtRoutesDict.find(x=>x.chapter==item.chapter).key;

      this.$router.push({
        name: LdtRoute.names.tab,
        params: {
          [p_Key]: item.source_id,
          tab: "overview"
        }
      });
    },
    onTaskClick:function(item){
      const { external_table , task_id} = item
      openModalRoute2(this,'editTaskModal',{ externalTable:external_table ,task_id:task_id})
      //openModalRoute2(this,'addTaskModal',{mode:'edit'});
    },


    onTaskAdd:function(payload){
     

      const task = {
        ...payload,
        assigned_users:payload.assigned_user,
        sent_user:this.$store?.getters?.account?.user?.user_id
      }

      //closeModalRoute(this);

      //console.log(this.$store?.getters?.account?.user?.user_id,task,"Add Task")

      this[ActionTypes.TasksList.INSERT.SINGLE](task);
    },

    onCancel: function() {
      closeModalRoute(this);
    },


    onDropdownChange:function(name,e){
      console.log(name,e)
      if(name=='chapter'){
        this.basicFilter[name] = e.value
      }
      else{
        this.selectedDict[name] = e;
        this.basicFilter[name] =  this.selectedDict[name] && this.selectedDict[name].length > 0 ? this.selectedDict[name].map((e) => e.value).join(","): undefined;
      }
      
      this.fetchListReset();
    },

    onDateChange: function ({ name, value }) {
      // console.log(name,value)
      this.basicFilter[name] = value;
      // if (this.basicFilter["start_date"]!=undefined && this.basicFilter["end_date"]!=undefined) {
        
      this.fetchListReset();
      // }
    },
    onEditTask:function(payload){

      const userIDs = payload?.assigned_users ?  payload?.assigned_users.split(',') : [];
      
      const users =  this.usersTV.filter(x => userIDs.includes(x.value.toString())).map(y=>{
        return y.text
      }).join()
      
      
      console.log(this.usersTV.filter(x => userIDs.includes(x.value)),"PAYLOAD",userIDs,this.usersTV)
      
      
      this[ActionTypes.TasksList.UPDATE.SINGLE]({
        name: "entry",
        item: { ...payload , users},
        value: '',
      });
    }

    
  }
};
</script>

<style lang="scss">
.cmp-catalog-statement-statement_list {
  .dt-page--body {
    --offset: 190px;
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  // .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;

  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>
